import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePostRequest } from '../../service/PostTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import { endPoints } from '../../Config';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import SecuredFileChange from '../../components/SecuredFileChange';

const AddQRCode = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const navigate = useNavigate();

    const customerImageRef = useRef(null);

    const dispatch = useDispatch();

    const QROptions = [
        { name: 'Static QR', id: 'static' },
        { name: 'Dynamic QR', id: 'dynamic' }
    ];

    const validationSchema = Yup.object().shape({
        // name: Yup.string()
        //  .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        // .required('This field is required')
        //   .matches(/^[a-zA-Z0-9\s]*$/, 'Name must contain only alphanumeric values'),
        // location: Yup.string()
        // .matches(/^\d+$/, 'location ')
        // .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        //   .required('This field is required'),
        // consumerId: Yup.string()
        // .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        //   .required('This field is required'),
        // dateOfBirth: Yup.string().required('This field is required'),
        // cnic: Yup.string()
        //  .matches(/^\d+$/, 'Cnic should only contain numbers')
        // .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        //   .required('This field is required'),
        // gender: Yup.string().required('This field is required'),
        // emailAddress: Yup.string()
        // .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        // .email('Invalid email')
        //  .required('This field is required'),
        // address: Yup.string()
        // .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        //   .required('This field is required'),
        // profileImageBase64: Yup.string().required('This field is required')
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            qrType: 'static',
            status: 'IN ACTIVE'
        }
    });

    const handleCustomerIcon = () => {
        customerImageRef.current.click();
    };

    function handleCustomerImageChange(event) {
        setSelectedFile(null);
        formik.setFieldValue('profileImageBase64', '');
        const selectedFile = event.target.files[0];
        const fileTypes = ['image'];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
        } else if (newFile) {
            formik.setFieldValue('profileImageBase64', newFile?.name);
            setSelectedFile(newFile);
        }
    }
    function formatedDate(originalDate) {
        const createDate = new Date(originalDate);

        const year = createDate.getFullYear();
        const month = (createDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
        const day = createDate.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="p-4">
                <div className="card Card__Round">
                    <h3 className="mb-4">Add QR CODE</h3>
                    <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                        <div className="p-fluid p-formgrid grid mb-5">
                            <div className="p-field col-12 md:col-12">
                                <div className="p-field">
                                    <label htmlFor="qrType">QR Code Type </label>
                                    <Dropdown id="qrType" name="qrType" value={formik.values.qrType} options={QROptions} optionValue="id" optionLabel="name" onChange={formik.handleChange} placeholder="Static Qr" />
                                    {formik.touched.qrType && formik.errors.qrType && <small className="p-error">{formik.errors.qrType}</small>}
                                </div>
                            </div>
                            {formik.values.qrType === 'static' ? (
                                <>
                                    <div className="p-field col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="refrenceId">
                                                Refrence Id<span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <InputText id="refrenceid" name="RefrenceId" placeholder="Enter a unique ID" max={50} value={formik?.values?.referenceId || ''} />

                                            {formik.touched.referenceId && formik.errors.referenceId && <small className="p-error">{formik.errors.referenceId}</small>}
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="title">
                                                Title <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <InputText id="title" name="title" placeholder="Enter a suitable title" value={formik?.values?.title} options={[]} onChange={formik.handleChange} className="w-full" />
                                            {formik.touched.title && formik.errors.title && <small className="p-error">{formik.errors.title}</small>}
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="mobileNumber">Mobile Number</label>
                                            <InputText id="mobileNumber" name="mobileNumber" value={formik?.values?.mobileNumber} onChange={formik.handleChange} className="w-full" />
                                            {formik.touched.mobileNumber && formik.errors.mobileNumber && <small className="p-error">{formik.errors.mobileNumber}</small>}
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="webHook">WebHook</label>
                                            <InputText id="webHook" name="webHook" placeholder="https://example.com" value={formik?.values?.webhook} onChange={formik.handleChange} className="w-full" />
                                            {formik.touched.webhook && formik.errors.webhook && <small className="p-error">{formik.errors.webhook}</small>}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="title">
                                                Title <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <InputText id="title" name="title" placeholder="Enter a suitable title" value={formik?.values?.title} options={[]} onChange={formik.handleChange} className="w-full" />
                                            {formik.touched.title && formik.errors.title && <small className="p-error">{formik.errors.title}</small>}
                                        </div>
                                    </div>
                                    <div className="p-field col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="refrenceId">
                                                Refrence Id <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <InputText id="refrenceid" name="RefrenceId" placeholder="Enter a unique ID" value={formik?.values?.referenceId || ''} options={[]} onChange={formik.handleChange} className="w-full" />

                                            {formik.touched.referenceId && formik.errors.referenceId && <small className="p-error">{formik.errors.referenceId}</small>}
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="amount">
                                                Amount <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <InputText id="amount" name="amount" placeholder="PKR" value={formik?.values?.amount} onChange={formik.handleChange} className="w-full" />
                                            {formik.touched.amount && formik.errors.amount && <small className="p-error">{formik.errors.amount}</small>}
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="expiry">
                                                Expiry <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <InputText id="expiry" name="expiry" placeholder="Enter expiry time(in hours)" value={formik?.values?.amount} onChange={formik.handleChange} className="w-full" />
                                            {formik.touched.amount && formik.errors.amount && <small className="p-error">{formik.errors.amount}</small>}
                                        </div>
                                    </div>

                                    <div className="col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="NotificationEmail">Notification Email</label>
                                            <InputText id="NotificationEmail" name="NotificationEmail" placeholder="Jhondoe@example.com" value={formik?.values?.webhook} onChange={formik.handleChange} className="w-full" />
                                            {formik.touched.webhook && formik.errors.webhook && <small className="p-error">{formik.errors.webhook}</small>}
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="webHook">WebHook</label>
                                            <InputText id="webHook" name="webHook" placeholder="https://example.com" value={formik?.values?.webhook} onChange={formik.handleChange} className="w-full" />
                                            {formik.touched.webhook && formik.errors.webhook && <small className="p-error">{formik.errors.webhook}</small>}
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="customerPrompt">Customer Prompt</label>
                                            <Dropdown id="customerPrompt" name="customerPrompt" placeholder="None" value={formik?.values?.webhook} onChange={formik.handleChange} className="w-full" />
                                            {formik.touched.webhook && formik.errors.webhook && <small className="p-error">{formik.errors.webhook}</small>}
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <div className="p-field">
                                            <label htmlFor="mobileNumber">Mobile Number</label>
                                            <InputText id="mobileNumber" name="mobileNumber" placeholder="https://example.com" value={formik?.values?.webhook} onChange={formik.handleChange} className="w-full" />
                                            {formik.touched.webhook && formik.errors.webhook && <small className="p-error">{formik.errors.webhook}</small>}
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="live__SearchBtn p-field col-12 md:col-12">
                                {/* <Button disabled={loading} loadingIcon={loadingIcon} icon={loadingIcon} iconPos="left" label="Search" className="Btn__Dark__Search" /> */}
                                <Button label="Save" icon="pi pi-search" className="Btn__Dark__Search" />

                                <Button
                                    label="Cancel"
                                    // onClick={(e) => resetHandle(e)}
                                    className="Btn__Transparent__Reset"
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </form>
    );
};

export default AddQRCode;
